var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMcpForAiAgentsMonochrome = function SvgMcpForAiAgentsMonochrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#454549",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m35.2 4 2.829 7.355c.676 1.76 1.015 2.64 1.541 3.38a7.2 7.2 0 0 0 1.696 1.695c.74.526 1.62.864 3.38 1.541L52 20.8l-7.355 2.829c-1.76.676-2.64 1.015-3.38 1.541a7.2 7.2 0 0 0-1.695 1.696c-.526.74-.865 1.62-1.541 3.38l-2.83 7.354-2.828-7.355c-.677-1.76-1.015-2.64-1.541-3.38a7.2 7.2 0 0 0-1.696-1.695c-.74-.526-1.62-.865-3.38-1.541L18.4 20.8l7.355-2.829c1.76-.677 2.64-1.015 3.38-1.541a7.2 7.2 0 0 0 1.695-1.696c.526-.74.864-1.62 1.541-3.38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m14.8 30.4 1.883 3.765c.637 1.275.956 1.912 1.381 2.464.378.49.817.93 1.307 1.307.552.425 1.19.744 2.464 1.381L25.6 41.2l-3.765 1.883c-1.275.637-1.912.956-2.464 1.381-.49.378-.93.817-1.307 1.307-.425.552-.744 1.19-1.381 2.464L14.8 52l-1.883-3.765c-.637-1.275-.956-1.912-1.381-2.464a7.2 7.2 0 0 0-1.307-1.307c-.552-.425-1.19-.744-2.464-1.381L4 41.2l3.765-1.883c1.275-.637 1.912-.956 2.464-1.381.49-.378.93-.817 1.307-1.307.425-.552.744-1.19 1.381-2.464z"
  })));
};
export default SvgMcpForAiAgentsMonochrome;